import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CreditDebitNoteDetail } from "../../types/credit-debit-note.type";
import { formatDateTimeBkk } from "../../utils/date";
import { NOTE_REASON_TYPE_LABEL, STOCK_RETURN_REASON_TYPE } from "./constants";

/**
 * What the note did to van stock, one line per fact. Only a RETURN credit note moves stock: into
 * the route the shop was bound to on the note date (that day's route stock); a cancel takes the
 * same pieces back out, once.
 */
const stockReturnFacts = (note: CreditDebitNoteDetail): string[] => {
  const isStockReturn =
    note.note_type === "CREDIT" && note.reason_type === STOCK_RETURN_REASON_TYPE;
  if (!isStockReturn) {
    return [`${NOTE_REASON_TYPE_LABEL[note.reason_type]}: ไม่มีการคืนสินค้าเข้าสต็อก`];
  }
  if (!note.stock_returned_at) {
    return [
      note.customer_code
        ? "ไม่ได้คืนสินค้าเข้าสต็อก"
        : "ไม่ได้คืนสินค้าเข้าสต็อก เพราะไม่ได้ระบุรหัสร้านค้า",
    ];
  }
  const facts = [
    `คืนเข้าสต็อกบนรถสาย ${note.return_route_code ?? "-"} เมื่อ ${formatDateTimeBkk(
      note.stock_returned_at,
    )}`,
  ];
  if (note.stock_reverted_at) {
    facts.push(
      `ดึงสินค้าที่รับคืนออกจากสต็อกแล้ว (ยกเลิกเอกสาร) เมื่อ ${formatDateTimeBkk(
        note.stock_reverted_at,
      )}`,
    );
  }
  return facts;
};

export default function StockReturnPanel({ note }: Readonly<{ note: CreditDebitNoteDetail }>) {
  return (
    <Paper>
      <Typography variant="subtitle1" fontWeight={700} mb={1}>
        สต็อกบนรถ
      </Typography>
      <Stack gap={0.5}>
        {stockReturnFacts(note).map((fact) => (
          <Typography key={fact} variant="body2">
            {fact}
          </Typography>
        ))}
      </Stack>
    </Paper>
  );
}
